import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 6 9 17l-5-5",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheck;
